import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import * as uuid from 'uuid';
import {TreeNode} from 'primeng/api';
import { mensaService } from '../../gestione-mensa.service';
import { HtmlEditorService, QuickToolbarService, ToolbarService, ToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import * as moment from 'moment';

@Component({
  selector: 'app-programma-edit',
  templateUrl: './programma-edit.component.html',
  styleUrls: ['./programma-edit.component.css'],
  providers: [MessageService,ConfirmationService,ToolbarService, HtmlEditorService, QuickToolbarService],
  encapsulation: ViewEncapsulation.None
})
export class ProgrammaEditComponent implements OnInit {
  @ViewChild('maintablepranzo') maintablepranzo:any;
  @ViewChild('maintablecena') maintablecena:any;
  
  primaData=new Date();

  pageTitle:string="";
  id:any='';
  backUrl:string='dashboard/gestionemensa/programma';
  ricetteList:any[]=[];
  action:any='';
  
    public tools: ToolbarSettingsModel = {
      type: 'Expand' as ToolbarSettingsModel['type'],
      items: ['Bold', 'Italic', 'Underline', 'OrderedList',
          'UnorderedList']};
  
  camerasList:any=[];
  loading:boolean = true;
  selectedItems:any[]=[];
  elencoPiattiPranzo: any = [];
  durataProgrammaList:any[]=[
   {value:1,label:'1 settimana'},
   {value:2,label:'2 settimane'},
   {value:3,label:'3 settimane'},
   {value:4,label:'4 settimane'}
  ];
  ricetteListAll:any[]=[];
  progr:any={
    struttura_id:0,
    dal_giorno:null,
    al_giorno:null,
    nome:'',
    durata:2,
    settimane:[],
  };
  cols:any[]=[
    { field: 'settimana', header: 'Settimana' },
    { field: 'giorno', header: 'Giorno' },
    { field: 'tipo', header: 'Tipo' },
  ];
  

  statoprogrammaListi=[
    {label:'NON CONFERMATO', value: 'NON CONFERMATO'},
    {label:'CONFERMATO', value: 'CONFERMATO'},
   
  ];

  tipopiattiList=[];
  
  
  constructor(
    private apiService: ApiService,
    public confirmationService: ConfirmationService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    private mensaservice: mensaService,
  ) { }


  ngOnInit(): void {
  
    this.tipopiattiList=this.mensaservice.getTipiPiatti();

    this.action=this.route.snapshot.paramMap.get('action');
    this.id=this.route.snapshot.paramMap.get('id');
    this.progr.struttura_id=this.route.snapshot.paramMap.get('struttura_id');
    this.pageTitle=this.route.snapshot.paramMap.get('struttura_name');
    if(this.route.snapshot.paramMap.get('id')){
     
      this.apiService.post('mensa/mensa_programma_getall',{id:this.id}).subscribe(data2 => {
        let cprogr = data2.Result[0];
        this.progr={
          struttura_id:cprogr.struttura_id,
          dal_giorno:new Date(cprogr.dal_giorno),
          al_giorno:new Date(cprogr.al_giorno),
          durata:cprogr.durata,
          nome:cprogr.nome,
          settimane:JSON.parse(cprogr.settimane)
        };
        this.loading=false;
      });
    } else {
      this.apiService.post('mensa/mensa_programma_getall',{struttura_id:this.route.snapshot.paramMap.get('struttura_id')}).subscribe(data2 => {
        data2.Result.forEach((cprogr:any)=>{
          let dataFine=new Date(cprogr.al_giorno);
          if(dataFine.getTime()>this.primaData.getTime()){
            this.primaData=dataFine;
          }
        });
        this.progr.dal_giorno=new Date(this.primaData.getTime() + (1000 * 60 * 60 * 24));
      });
      this.caricasettimane();
      this.loading=false;
    }
    this.apiService.post('mensa/mensa_ricette_getall',{struttura_id:17}).subscribe(data2 => {
      this.ricetteListAll=data2.Result;
      this.ricetteList =[{
        label:'',
        value: 0
      }];
      data2.Result.forEach((r) => {
        this.ricetteList.push({
          label:r.nome,
          value: r.id
        })
      });
   
      this.loading=false;
    });
    
  }

  valida(){
    return true;
  }
  salvaeconferma(){
    let today=new Date().getTime();
    if(!this.progr.dal_giorno || !this.progr.al_giorno || this.progr.dal_giorno.getTime() >=this.progr.al_giorno.getTime() ){
       this.addSingle('error', 'Errore', 'Periodo non corretto');
       return;
    }
     if(this.progr.dal_giorno<today || this.progr.al_giorno<today ){
       this.addSingle('error', 'Errore', 'Periodo non corretto: le date devono essere maggiori di quella odierna');
       return;
    }
    /*
    if(this.progr.dal_giorno<=this.primaData ){
       this.addSingle('error', 'Errore', 'Periodo non corretto: le date devono essere maggiori dell\'ultimo periodo di programmazione salvato');
       return;
    }
    */
   

    this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Si conferma il programma. Verranno impostati pasti nel calendario?',
        header: 'Attenzione',
        accept: () => {
          this.salva(1);
        },
        reject: () => {
          
        },
    });
  }
  salva(what){
    
    let cprogr:any={
      struttura_id:this.progr.struttura_id,
      dal_giorno:this.progr.dal_giorno,
      al_giorno:this.progr.al_giorno,
      durata:this.progr.durata,
      nome:this.progr.nome,
      settimane:JSON.stringify(this.progr.settimane)
    };
    if(this.id){
      cprogr.id=this.id
    }
    if(what==1){
      cprogr.impostacalendario=true;
    }
    this.apiService.post('mensa/mensa_programma_update',cprogr).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      this.router.navigateByUrl(this.backUrl);
    });
  }
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


  onRowEditCancelPranzo(ev:any){

  }
  deleteSezionePranzo(ev:any,list:any){
    
    list.forEach((c:any,ind:number)=>{
      if(c.id==ev.id){
        list.splice(ind,1);
      }
    });
   
  }

  onRowEditSavePranzo(ev:any){
    
  }
  onRowEditSaveCena(ev:any){
    
  }
  
  onRowEditInitCena(ev:any){
    
  }
  onRowEditInitPranzo(ev:any){
    
  }
  caricaRicetta(pp:any){
    
    let f=this.ricetteListAll.filter((x:any)=> x.id==pp.ricetta_id);
    if((f)&&(f.length>0)){
      pp.nome=f[0].nome;
      pp.tipo=f[0].tipo;
      pp.ingredienti=f[0].ingredienti;
      pp.allergeni=f[0].allergeni;
    }
    
  }

  nuovpiatto(record){
    const newS:any = {
      id:uuid.v4(),
      nome: '',
      tipo:'Primo',
      ingredienti:'<p></p>',
      ricetta_id:null
    };
 
    record.push(newS);

    
  }
  

  nuovpiattopranzo(){
    const newS:any = {
      id:uuid.v4(),
      nome: '',
      tipo:'Primo',
      ingredienti:'<p></p>',
      ricetta_id:null
    };
 
    this.progr.pranzo.unshift(newS);
   
   
  }
  
  nuovpiattocena(){
    const newS:any = {
      id:uuid.v4(),
      nome: '',
      tipo:'Primo',
      ingredienti:'<p></p>',
      ricetta_id:null
    };
 
    this.progr.cena.unshift(newS);
   
    

  }
  getRicetta(ricetta:any){

    let f=this.ricetteList.filter((x:any)=> x.value==ricetta);
    if((f)&&(f.length>0)){
      return f[0].label;
    } else {
      return '';
    }
  }
  
  getTipo(tipo:any){

    let f=this.tipopiattiList.filter((x:any)=> x.value==tipo);
    if((f)&&(f.length>0)){
      return f[0].label;
    } else {
      return '';
    }
  }

  caricasettimane(){
    if(this.progr.durata<this.progr.settimane.length){
      this.progr.settimane.splice(this.progr.durata -this.progr.settimane.length); 
    }

    for(let j=0;j<this.progr.durata;j++){
      let settimana={
        nome:'Settimana '+(j+1),
        giorni:[
          {
            giorno:'Lunedì',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Martedì',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Mercoledì',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Giovedì',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Venerdì',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Sabato',
            pranzo:[],
            cena:[]
          },
          {
            giorno:'Domenica',
            pranzo:[],
            cena:[]
          }
        ]
      };

      if(!this.progr.settimane[j]){
        console.log(this.progr.settimane);
        this.progr.settimane.push(settimana);
      }
    }
  }

  changeDurata(event){
    this.caricasettimane();
  }
  duplica(){
    
     this.apiService.post('mensa/mensa_programma_duplica',{id:this.id}).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      this.router.navigateByUrl(this.backUrl);
    });
  }
}
